// extracted by mini-css-extract-plugin
export var actionText = "_sp-4";
export var container = "_sp-0";
export var leftSection = "_sp-1";
export var rightSection = "_sp-2";
export var settingsButton = "_sp-6";
export var settingsIcon = "_sp-7";
export var shortcut = "_sp-5";
export var shortcutGroup = "_sp-3";